import ILocationService from './ILocationService';

import { CoordinateModel } from '../../models/coordinate.model';
import { DataSchemeFactSheet, FactSheetModel } from '../../models/factSheet.model';
import { NoticeOrErrorModel } from '../../models/notice.error.model';
import { GetProductDetailsModel, GetProductListModel, GetProductModel } from '../../models/products.model';
import { DataSchemeRequest, GetSujetCheckModel, RequestModel } from '../../models/request.model';
import ApiClient, { ApiMethodType } from '../../providers/ApiClient';
import {
    DataSchemeList,
    DataSchemeFilter,
    DataSchemeProduct,
    DataSchemeNeighborsProducts,
    DataSchemeSingleProduct,
    SmartPhraseModel,
} from '../../store/location';

import { getProductFilterPayload } from '../../utils';

class LocationService implements ILocationService {
    public getFactSheet(payload: FactSheetModel): Promise<DataSchemeFactSheet> {
        return ApiClient.request(`factsheet`, { method: ApiMethodType.POST }, payload);
    }

    public getNeighborsProducts(payload: {
        bookingyear?: number;
        urn: string | string[];
    }): Promise<DataSchemeNeighborsProducts> {
        return ApiClient.request(`neighbors`, { method: ApiMethodType.GET }, payload);
    }

    public getProduct(payload: GetProductModel): Promise<DataSchemeProduct> {
        return ApiClient.request(`product`, { method: ApiMethodType.GET }, payload);
    }

    public getProductDetails(payload: GetProductDetailsModel): Promise<DataSchemeSingleProduct> {
        return ApiClient.request(`productdetaildata`, { method: ApiMethodType.GET }, payload);
    }

    public getProductFilter(payload: {
        bookingyear?: number;
        coordinate?: CoordinateModel;
        search?: string;
    }): Promise<{ data: DataSchemeFilter; error?: NoticeOrErrorModel[]; notices?: NoticeOrErrorModel[] }> {
        return ApiClient.request(`productfilter`, { method: ApiMethodType.POST }, getProductFilterPayload(payload));
    }

    public getProductList(payload: GetProductListModel, controller?: AbortController): Promise<DataSchemeList> {
        return ApiClient.request(`select`, { method: ApiMethodType.POST }, payload, controller);
    }

    public getSmartPhrases(): Promise<SmartPhraseModel> {
        return ApiClient.request(`smartphrase`, { method: ApiMethodType.GET });
    }

    public getSujetcheckImages(payload: GetSujetCheckModel): Promise<DataSchemeRequest> {
        return ApiClient.request(`sujetreport`, { method: ApiMethodType.POST }, payload);
    }

    public postSujetcheckImage(payload: FormData): Promise<DataSchemeRequest> {
        return ApiClient.request(`sujetupload`, { method: ApiMethodType.POST_MULTIPART }, payload);
    }

    public sendRequest(payload: RequestModel): Promise<DataSchemeRequest> {
        return ApiClient.request(`productconsultation`, { method: ApiMethodType.POST }, payload);
    }
}

export default new LocationService();
